import React, { forwardRef, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { Box, Flex } from '@chakra-ui/layout';
import { FormControl, FormErrorMessage, Input } from '@chakra-ui/react';
import { IconButton } from '@chakra-ui/button';
import { MdCheck, MdClose } from 'react-icons/md';
import { useSharedExperiencesApi } from '../../lib/useSharedExperiencesApi';
import { SharedExperiencesContext } from '../../lib/sharedExperiencesProvider';
const SharedExperienceNameForm = forwardRef((props, ref) => {

    const {
    sharedExperience,
    sharedExperienceId,
    refreshSharedExperience,
  } = useContext(SharedExperiencesContext);
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
    onCancel
  } = props;
  const { register, handleSubmit, formState: { errors, isSubmitting, isValid } } = useForm({
    mode: 'onChange',
    defaultValues: {
      name: sharedExperience.name
    }
  });
  const sharedExperiencesApi = useSharedExperiencesApi();
  const onSubmit = async (data) => {
    try {
      if(onSubmitting) {
        onSubmitting();
      }
      const name = data.name;
      if(name && sharedExperienceId) {
        await sharedExperiencesApi.updateSharedExperienceName(sharedExperience.id, data.name);
        await refreshSharedExperience();
      }
      if(onSubmitted) {
        onSubmitted();
      }

    } catch (error) {
      console.error('Error updating shared experiences name:', error);
    }
  };
  return (
    <Box>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          alignItems={'center'}
          flexDirection={'column'}
          gap={2}
        >
          <FormControl isInvalid={errors.name}>
            <Input
              placeholder="Name"
              {...register('name', { 
                required: 'Name is required', 
                minLength: { 
                  value: 3, 
                  message: 'Name must be at least 3 characters' 
                } 
              })}
            />
            <FormErrorMessage>{errors.name && errors.name.message}</FormErrorMessage>
          </FormControl>
          <Flex display={"flex"} gap={2}>
            {onCancel && (
              <IconButton
                variant="greyOutline"
                icon={<MdClose />}
                onClick={onCancel}
              />
            )}
            <IconButton
              style={{
                display: hideSave ? 'none' : 'inherit',
              }}
              ref={ref}
              icon={<MdCheck />}
              type="submit"
              aria-label="save"
              variant="greenOutline"
              isLoading={isSubmitting}
              isDisabled={!isValid}
            />
          </Flex>
        </Flex>
      </form>
    </Box>
  );
});
export default SharedExperienceNameForm;